<template>
<van-pull-refresh v-model="refreshing" @refresh="onSearch">
  <van-search
    v-model="value"
    placeholder="喜欢啥，让我帮你找吧"
    @search="onSearch"
    show-action
  >
  <div slot="action" @click="onSearch">搜索</div>
  </van-search>

  <div ref="filter" style="display: none;">
    <van-tabs v-model="cata" @click="onCata" class="cata_tab">
      <van-tab v-for="c in catas" :title="c" :key="c"></van-tab>
    </van-tabs>
  </div>

  <van-row>
    <van-col span="16">
      <van-tabs v-model="sort" @click="onSort" :color="tabColor" sticky>
        <van-tab title="销量最高"></van-tab>
        <van-tab title="返比最高"></van-tab>
        <van-tab title="价格最低"></van-tab>
      </van-tabs>
    </van-col>
    <van-col span="8" class="coupon_tab" sticky>
      <van-switch v-model="couponOnly" size="15px" @input="onCoupon" />仅显示有券
    </van-col>
  </van-row>

  <van-list
    v-model="loading"
    :finished="finished"
    @load="onLoad"
    id="list"
  >
  <div
      v-for="(item, index) in list"
      class="item_card"
      :key="item.num_iid">
        <img :src="item.thumb" class="card_img" @click="preview(item.thumbs)"/>
        <div class="card_title">{{item.title}}</div>
        <van-progress
          slot="desc"
            v-model="item.remain"
            :percentage="parseInt(item.remain)*100/item.total"
            :pivot-text="item.total ? '剩' + item.remain + '张' : ''"
            pivot-color="#7232dd"
            color="linear-gradient(to right, #be99ff, #7232dd)"
            style="margin: 8px 0px;"
          />
        <div style="margin: 3px 0px;">
          <div style="float: left;">
            <van-tag plain>{{item.volume}}</van-tag>
          </div>
          <div style="float: right;">￥{{item.price}}</div>
          <div style="clear: both;" />
        </div>
        <div style="margin: 3px 0px;">
          <div style="float: left;">
            <van-tag type="danger">{{item.coupon}}</van-tag>
            <van-tag plain type="danger">约返{{item.commission}}</van-tag>
          </div>
          <div style="float: right; text-decoration: line-through; font-size: 10px; color: #aaa">￥{{item.orig_price}}</div>
          <div style="clear: both;" />
        </div>
        <van-button type="danger" round @click="onDialog(item.num_iid, item.title, '.item_card:nth-child('+(index+1)+')')" style="margin: 10px 0px; width: 100%; font-size: 14px;">我要买</van-button>
  </div>
  <div style="clear: both;" />
    <!--<van-card
      v-for="item in list"
      :key="item"
      :tag="item.shop_dsr"
      :price="item.price"
      :origin-price="item.orig_price"
    >
      <div slot="footer">
        <van-tag type="danger">{{item.coupon}}</van-tag>
        <van-tag plain type="danger">约返{{item.commission}}</van-tag>
        &nbsp;
        <van-button type="danger" size="mini" @click="onDialog(item.num_iid, item.title, $event)">我要买</van-button>
      </div>
      <div slot="title">
        <div>{{item.title}}</div>
        <div>&nbsp;</div>
      </div>
      <van-progress
        slot="desc"
          v-model="item.remain"
          :percentage="parseInt(item.remain)*100/item.total"
          :pivot-text="item.total ? '剩' + item.remain + '张' : ''"
          pivot-color="#7232dd"
          color="linear-gradient(to right, #be99ff, #7232dd)"
        />
      <div slot="tags">
      </div>
      <div slot="thumb">
        <img :src="item.thumb" class="van-card__img"  @click="preview(item.thumbs)"/>
        <van-tag plain>{{item.volume}}</van-tag>
      </div>
    </van-card>-->
  </van-list>

  <van-popup v-model="show" class="tpwd_dlg" :lock-scroll=lock_scroll :get-container="sel">
    <div>点击按钮复制淘口令</div>
    <div>打开淘宝即可返利购买</div>
    <div>&nbsp;</div>
    <input type="text" v-model="taopwd" style="text-align: center; width: 100%;">
    <div>&nbsp;</div>
    <van-button type="danger" size="large" round @click="doCopy" :loading="btn_loading">点击复制</van-button>
  </van-popup>
</van-pull-refresh>
</template>

<script>
import {
  Tag,
  Row,
  Col,
  Tab,
  Tabs,
  Cell,
  List,
  Card,
  Field,
  Search,
  Popup,
  Toast,
  Switch,
  Button,
  Progress,
  PullRefresh,
  ImagePreview
} from "vant";

import wx from 'weixin-js-sdk'

export default {
  components: {
    [Tag.name]: Tag,
    [Row.name]: Row,
    [Col.name]: Col,
    [Tab.name]: Tab,
    [Tabs.name]: Tabs,
    [Cell.name]: Cell,
    [List.name]: List,
    [Card.name]: Card,
    [Field.name]: Field,
    [Popup.name]: Popup,
    [Search.name]: Search,
    [Switch.name]: Switch,
    [Button.name]: Button,
    [Progress.name]: Progress,
    [PullRefresh.name]: PullRefresh
  },
  data() {
    return {
      catas: ["热卖","9块9","女装","美妆","食品","母婴","男装","家居","数码","鞋包","内衣","运动","钜惠"],
      cata: ~~this.$route.query.cata,
      list: [],
      loading: false,
      finished: false,
      pn: 0,
      ps: 6,
      value: this.$route.query.wd,
      images: [],
      show: false,
      taopwd: "",
      btn_loading: false,
      couponOnly: (this.$route.query.c > 0 ? true : false),
      sort: ~~this.$route.query.sort,
      refreshing: false,
      sel: '',
      lock_scroll: false,
      tabColor: "#F44F0D",
    };
  },
  methods: {
    preview(thumbs) {
      if (Array.prototype.isPrototypeOf(thumbs) && thumbs.length !== 0) {
        ImagePreview(thumbs);
        Toast("点击图片可返回商品列表");
      }
    },
    onDialog(num_iid, title, sel) {
      let el = document.querySelector(sel);
      el.style.height = (window.getComputedStyle(el).height);

      this.sel = sel;
      this.show = true;
      this.taopwd = "正在加载...";
      this.btn_loading = true;
      this.$http
        .get("https://cb.xhare.cn/cvt", {
          params: {
            openid: sessionStorage.getItem("openid"),
            num_iid: num_iid,
            title: title
          }
        })
        .then(
          function(res) {
            if (res.data.code == 0) {
              this.taopwd = res.data.data;
              this.btn_loading = false;
              /*this.$dialog.alert({
                title: '长按全选复制框内内容',
                message: res.data.data
              });*/
            }
          }.bind(this)
        )
        .catch(
          function() {
            this.redirect();
          }.bind(this)
        );
    },
    onSearch() {
      this.pn = 0;
      this.list = [];
      this.loading = false;
      this.finished = false;
      this.onLoad();
    },
    query(openid) {
      this.$refs.filter.style.display = (this.value && this.value.length > 0) ? "none" : "";
      this.$http
        .get("https://cb.xhare.cn/q", {
          params: { openid: openid, pn: this.pn, ps: this.ps, wd: this.value, coupon: this.couponOnly == true ? 1 : 0, sort: this.sort + 1, cata: this.catas[this.cata] }
        })
        .then(
          function(res) {
            if (res.data.code == 0) {
              this.refreshing = false;
              if (res.data.data.length < this.ps) {
                this.finished = true;
              }
              if (res.data.data.length > 0) {
                res.data.data.forEach(element => {
                  if (element.title && element.title.length > 0) {
                    this.list.push({
                      num_iid: element.num_iid,
                      title: element.title,
                      thumb: element.thumb,
                      thumbs: element.thumbs,
                      price: element.price,
                      coupon: element.coupon,
                      provcity: element.provcity,
                      remain: element.remain,
                      total: element.total,
                      shop_dsr: element.shop_dsr,
                      orig_price: element.orig_price,
                      commission: element.commission,
                      volume: element.volume
                    });
                  }
                });
              }

              if (this.pn == 0) {
                this.getConfig(openid);
              }

              this.pn = res.data.next;
            }
            this.loading = false;
          }.bind(this)
        )
        .catch(
          function() {
            this.redirect();
          }.bind(this)
        );
    },
    redirect() {
      window.location.href =
        "https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx1939c838a577589a&redirect_uri=https://m.xhare.cn/i/%23q%3fwd=" +
        encodeURIComponent(this.$route.query.wd) + "%26sort=" + this.sort + "%26cata=" + this.cata + "%26c=" + (this.couponOnly == true ? 1 : 0) +
        "&response_type=code&scope=snsapi_base&state=ucenter";
    },
    onLoad() {
      let openid = sessionStorage.getItem("openid");
      if (openid) {
        this.query(openid);
      } else {
        this.$http
          .get("https://cb.xhare.cn/openid", {
            params: {
              code: (window.location.search
                .substr(1)
                .match(/(^|&)code=([^&]*)(&|$)/i) || [])[2]
            }
          })
          .then(
            function(res) {
              if (res.data.openid == "") {
                this.redirect();
              } else {
                this.query(res.data.openid);
                sessionStorage.setItem("openid", res.data.openid);
              }
            }.bind(this)
          )
          .catch(
            function() {
              this.redirect();
            }.bind(this)
          );
      }
    },
    doCopy() {
      this.$copyText(this.taopwd).then(
        function() {
          Toast.success('复制成功，快去抢购吧');
          this.show = false;
        }.bind(this),
        function() {
          Toast.fail('复制失败，请手动复制');
        }.bind(this)
      );

    },
    mounted() {
    },
    onCoupon(couponOnly) {
      this.couponOnly = couponOnly;
      this.onSearch();
    },
    /* eslint-disable*/
    onSort(index, title) {
      this.sort = index;
      this.onSearch();
    },
    /* eslint-disable*/
    onCata(index, title) {
      this.cata = index;
      this.onSearch();
    },
    // 微信分参数
    getConfig(openid) {
      let url = location.href.split('#')[0] //获取锚点之前的链接
      this.$http.get('https://cb.xhare.cn/jsconfig',{
        params: {
          url: url,
          openid: openid,
          u: this.$route.query.u
        }
      }).then(response => {
          let res = response.data.data;
          this.wxInit(res);
        })
    },
    // 微信分享
    wxInit(res) {
      let url = location.href.split('#')[0] //获取锚点之前的链接
      let wd = this.value ? this.value : this.$route.query.wd;
      let links = url + "#/q?wd=" + encodeURIComponent(wd) + '&u=' + res.u + "&sort=" + this.sort + "&cata=" + this.cata + "&c=" + (this.couponOnly == true ? 1 : 0);
      let title = (res.nickname ? res.nickname : '我') + '在【XHARE】';
      if (wd.length > 10) wd = wd.substr(0, 10) + '...';
      let desc = '分享' + (res.nickname ? 'ta' : '') + '发现的好物' + (wd ? '【' + wd + '】' : wd) + '给你';
      let imgUrl = (this.list && this.list.length > 0) ? this.list[0].thumb : res.thumb;
      wx.config({
        debug: false,
        appId: res.appId,
        timestamp: res.timestamp,
        nonceStr: res.nonceStr,
        signature: res.signature,
        jsApiList: ['onMenuShareTimeline', 'onMenuShareAppMessage', 'onMenuShareQQ', 'onMenuShareWeibo', 'onMenuShareQZone']
      });
      wx.ready(function() {
        let config = {
          title: title, // 分享标题
          desc: desc, // 分享描述
          link: links, // 分享链接
          imgUrl: imgUrl, // 分享图标
          success: function() {
            //({
              //message: "成功分享到朋友圈"
            //});
          },
          cancel: function() {
            //({
              //message: "分享失败,您取消了分享!"
            //});
          }
        };
        wx.onMenuShareTimeline(config);
        wx.onMenuShareAppMessage(config);
        wx.onMenuShareQQ(config);
        wx.onMenuShareWeibo(config);
        wx.onMenuShareQZone(config);
      });
      wx.error(function(err) {
        alert(JSON.stringify(err))
      });
    }
  }
};
</script>

<style lang="less">
.van-card__left {
  text-align: left;
}
.swipe_img {
  width: 100%;
  height: 100%;
}
.van-progress {
  height: 10px;
}
.tpwd_dlg {
  color: chocolate;
  border-radius: 15px;
  padding: 50px 20px 20px 20px;
  font-size: 12px;
  position: relative;
  top: -200px;
}
.item_card {
  width: 45%;
  float: left;
  margin: 2%;
  border-bottom-left-radius: 3%;
  border-bottom-right-radius: 3%;
}
.card_img {
  border-radius: 3%;
  max-width: 100%;
}
.card_title {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 12px;
  margin: 5px 0px;
}
.coupon_tab {
  line-height: 44px;
  font-size: 14px;
}
.cata_tab .van-tab {
  font-size: 18px;
}
</style>
